import React, { useState } from 'react';
import { FaLaptop, FaClock, FaShieldAlt, FaCheckCircle, FaUser, FaEnvelope, FaPhone, FaFileAlt, FaIdCard, FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa';
import videoCallImage from '../assets/images/video-call.jpg';
import '../styles/OnlineNotarizationPage.css';

const OnlineNotarization = () => {
  const [showScheduling, setShowScheduling] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    documentType: '',
    idType: '',
    address: ''
  });

  const steps = [
    {
      icon: <FaLaptop size={30} />,
      title: 'Schedule Appointment',
      description: 'Book a time that works for you'
    },
    {
      icon: <FaShieldAlt size={30} />,
      title: 'Verify Identity',
      description: 'Secure ID verification process'
    },
    {
      icon: <FaCheckCircle size={30} />,
      title: 'Notarize Documents',
      description: 'Legally binding notarization'
    },
    {
      icon: <FaClock size={30} />,
      title: 'Receive Documents',
      description: 'Get your documents in minutes'
    }
  ];

  const documentTypes = [
    'Affidavit',
    'Power of Attorney',
    'Deed',
    'Will',
    'Loan Documents',
    'Other'
  ];

  const idTypes = [
    'Driver License',
    'Passport',
    'State ID',
    'Military ID',
    'Other Government ID'
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmitInfo = (e) => {
    e.preventDefault();
    setCurrentStep(2); // Move to calendar step
  };

  const handleScheduleAppointment = (date, time) => {
    // Here you would typically send the data to your backend
    console.log({ ...formData, appointmentDateTime: `${date} at ${time}` });
    alert('Appointment scheduled successfully!');
    setShowScheduling(false);
    setCurrentStep(1);
  };

  return (
    <div className="online-page">
      <div className="online-hero">
        <div className="hero-content">
          <h1>Remote Online Notarization</h1>
          <p>Get your documents notarized from anywhere in Washington</p>
          <button 
            onClick={() => setShowScheduling(true)} 
            className="cta-button"
          >
            Schedule Online Session
          </button>
        </div>
      </div>
      
      <div className="how-it-works" id="how-it-works">
        <h2>The Online Notarization Process</h2>
        <div className="steps-container">
          {steps.map((step, index) => (
            <div className="step-card" key={index}>
              <div className="step-icon">{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
      
      <div className="video-demo-section">
        <img src={videoCallImage} alt="Video Notarization" className="demo-image" />
        <div className="demo-content">
          <h2>Secure Video Conference</h2>
          <p>
            Our platform uses bank-level encryption to protect your sensitive documents 
            during the notarization process. You'll meet with Professor Njenga via 
            high-quality video conference.
          </p>
          <button 
            onClick={() => setShowScheduling(true)} 
            className="demo-button"
          >
            Schedule Online Session
          </button>
        </div>
      </div>

      {/* Scheduling Modal */}
      {showScheduling && (
        <div className="scheduling-modal">
          <div className="modal-content">
            <button 
              className="close-button" 
              onClick={() => {
                setShowScheduling(false);
                setCurrentStep(1);
              }}
            >
              &times;
            </button>

            {currentStep === 1 && (
              <div className="info-form-step">
                <h2><FaUser /> Client Information</h2>
                <form onSubmit={handleSubmitInfo}>
                  <div className="form-group">
                    <label><FaUser /> Full Legal Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label><FaEnvelope /> Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label><FaPhone /> Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label><FaFileAlt /> Document Type</label>
                    <select
                      name="documentType"
                      value={formData.documentType}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Document Type</option>
                      {documentTypes.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label><FaIdCard /> Identification Type</label>
                    <select
                      name="idType"
                      value={formData.idType}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select ID Type</option>
                      {idTypes.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label><FaMapMarkerAlt /> Address (for notary record)</label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <button type="submit" className="submit-button">
                    Continue to Scheduling
                  </button>
                </form>
              </div>
            )}

            {currentStep === 2 && (
              <div className="calendar-step">
                <h2><FaCalendarAlt /> Select Appointment Time</h2>
                <div className="calendar-container">
                  {/* Simple date picker - you can enhance this with a library */}
                  <div className="form-group">
                    <label>Select Date</label>
                    <input 
                      type="date" 
                      min={new Date().toISOString().split('T')[0]}
                    />
                  </div>

                  <div className="form-group">
                    <label>Select Time (Pacific Time)</label>
                    <select>
                      <option value="09:00">9:00 AM</option>
                      <option value="10:00">10:00 AM</option>
                      <option value="11:00">11:00 AM</option>
                      <option value="13:00">1:00 PM</option>
                      <option value="14:00">2:00 PM</option>
                      <option value="15:00">3:00 PM</option>
                    </select>
                  </div>

                  <div className="appointment-summary">
                    <h3>Appointment Summary</h3>
                    <p><strong>Name:</strong> {formData.name}</p>
                    <p><strong>Document:</strong> {formData.documentType}</p>
                    <p><strong>ID Type:</strong> {formData.idType}</p>
                  </div>

                  <button 
                    onClick={() => handleScheduleAppointment('2023-11-20', '10:00 AM')}
                    className="submit-button"
                  >
                    Confirm Appointment
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default OnlineNotarization;